/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc
 */

export let ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError;
(function (_ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError) {})(ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError || (ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError = {}));
export let ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError;
(function (_ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError) {})(ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError || (ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError = {}));
export const getProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getProducts',
  auth: 'external',
  fingerprint: 'y60Ckx8OiE98ic51ILFzTZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductsV2',
  auth: 'external',
  fingerprint: 'y60Ckx8OiE98ic51ILFzTfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBundleRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getBundle',
  auth: 'external',
  fingerprint: 'MecQcEhAC43eGrqy_S_6wJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAddOnsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getAddOns',
  auth: 'external',
  fingerprint: 'W1sIsXps8S0cTK6AliWoS5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicAddOnsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicAddOnsV2',
  auth: 'external',
  fingerprint: 'W1sIsXps8S0cTK6AliWoS_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getGrowthPurchaseOptions',
  auth: 'external',
  fingerprint: 'pVh7oN-TcNvNcgDdIob235wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicGrowthPurchaseOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicGrowthPurchaseOptionsV2',
  auth: 'external',
  fingerprint: 'KTof_xqYSCjNcgDdIob23_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsUsingCombinedTermsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getGrowthPurchaseOptionsUsingCombinedTerms',
  auth: 'external',
  fingerprint: '5fhFB1_q8zfOvw0uJxxD4pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicCurrencyResponseRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCurrencyResponse',
  auth: 'external',
  fingerprint: 'LcY_1HcXExpCxNsiV75fV5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicCurrencyV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCurrencyV2',
  auth: 'external',
  fingerprint: '0A0s8MXPGwNCxNsiV75fV_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicPhoneNumberRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPhoneNumber',
  auth: 'external',
  fingerprint: '3XnPSFhmU52JvnxBO5sLIUIvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicPhoneNumberV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPhoneNumberV2',
  auth: 'external',
  fingerprint: '2Zi9eBzh3FKJvnxBO5sLIfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicFeatureFlagsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicFeatureFlags',
  auth: 'external',
  fingerprint: 'xqbfhmS3i9U9llyZwSnPm0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicFeatureFlagsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicFeatureFlagsV2',
  auth: 'external',
  fingerprint: 'PX4qAyKA8wE9llyZwSnPm_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicPricingPageDetailsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPricingPageDetails',
  auth: 'external',
  fingerprint: 'yMREVRptkqIpmSkMPLJIb0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductUseCasesV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductUseCasesV2',
  auth: 'external',
  fingerprint: 'NKmN02BwKb6xd1rAYAJirvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductUseCasesV3Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductUseCasesV3',
  auth: 'external',
  fingerprint: 'NKmN02BwKb6xd1rAYAJirvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductPlanRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductPlan',
  auth: 'external',
  fingerprint: 'tUsXtMG2actdbWZLJi1_MvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductBadgesRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductBadges',
  auth: 'external',
  fingerprint: '08RwPDYX0FPpwqK0OaEJuvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductTierOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductTierOptions',
  auth: 'external',
  fingerprint: 'TE3UsysQwwLljforLeTzMfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductsBySkuIdRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getProductsBySkuId',
  auth: 'external',
  fingerprint: 'bM6rll3EdSkTq2UsiVecb_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductConfigurationOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductConfigurationOptions',
  auth: 'external',
  fingerprint: 'EcrdcPCOV7sb1yUirYzgvvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicCabProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCabProducts',
  auth: 'external',
  fingerprint: 'oX0aVL87gr18ic51ILFzTfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCreditActionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getCreditActions',
  auth: 'external',
  fingerprint: 'vL3CC-eMFa6sKL1Vob5ad_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};